import React, { useState } from "react";
// import logo from "../../assets/images/newTeleSecure360logo.svg";
import logo from "../../assets/images/newTeleLogo.svg";
import {
  FaInstagramSquare,
  FaInstagram,
  FaLinkedin,
  FaLinkedinIn,
  FaFacebookF,
  FaTwitter,
} from "react-icons/fa";

const NewFooter = (props) => {
  return (
    <div className="FooterBackground px-8 py-20 flex justify-between w-full gap-4 grid grid-rows-1 grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5">
      <div className="col-span-1 md:col-span-2 max-w-md">
        <div className="w-full">
          <img className="h-auto w-48 md:w-80" src={logo} alt="logo" />

          <div className="">
            <span>
            TeleSecure360 is a secure, HIPPA compliant telemedicine platform that helps healthcare providers deliver seamless virtual care. From appointment scheduling and video consultations to electronic prescriptions, patient records, and secure messaging, we simplify healthcare for clinics, hospitals, and patients.
            </span>
          </div>

          <div
            className="flex gap-y-4 gap-x-8 flex-wrap pt-8 items-center"
            style={{ color: "#52525B" }}
          >
            <FaTwitter className="w-8 h-8" />
            <FaFacebookF className="w-8 h-8" />
            <FaInstagram className="w-8 h-8" />
            <FaLinkedinIn className="w-8 h-8" />
          </div>
        </div>
      </div>

      {/* <div className="flex md:col-span-3 w-full flex-wrap"> */}
      <div className="col-span-1 w-full">
        <div className="text-primary text-lg font-semibold pb-4">Company</div>
        <div
          className="pb-2 cursor-pointer"
          tabIndex="0"
          onClick={() => {
            window.open("https://telesecure360.com/about/", "_blank");
          }}
        >
          About
        </div>
        <div className="pb-2">Features</div>
        <div className="pb-2">Works</div>
        <div className="pb-2">Career</div>
      </div>

      <div className="col-span-1 w-full">
        <div className="text-primary text-lg font-semibold pb-4">Help</div>
        <div
          className="pb-2 cursor-pointer"
          tabIndex="0"
          onClick={() => {
            window.open("https://telesecure360.com/contact/", "_blank");
          }}
        >
          Customer Support
        </div>
        <div className="pb-2">Delivery Details</div>
        <div className="pb-2">Terms & Conditions</div>
        <div className="pb-2">Privacy Policy</div>
      </div>

      <div className="col-span-1 w-full">
        <div className="text-primary text-lg font-semibold pb-4">Resources</div>
        <div className="pb-2">Free eBooks</div>
        <div className="pb-2">Development Tutorial</div>
        <div className="pb-2">How to - Blog</div>
        <div className="pb-2">Youtube Playlist</div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default NewFooter;
